var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "DialogConfirmVerifiedPayment__Component" }, [
    _c("div", { staticClass: "modal-card" }, [
      _c("header", { staticClass: "modal-card-head" }, [
        _c("p", { staticClass: "modal-card-title" }, [_vm._v("וידוא תשלום")]),
        _c("button", {
          staticClass: "delete",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.$emit("close")
            }
          }
        })
      ]),
      _c("section", { staticClass: "modal-card-body" }, [
        _c("p", [
          _vm._v(
            "האם להשלים את ההסבות עבור " +
              _vm._s(_vm.reports.length) +
              " דוחות נבחרים?"
          )
        ]),
        _vm.reportNumbers && _vm.reportNumbers.length
          ? _c(
              "ul",
              _vm._l(_vm.reportNumbers, function(num) {
                return _c("li", { key: num }, [_vm._v(_vm._s(num))])
              }),
              0
            )
          : _vm._e()
      ]),
      _c(
        "footer",
        { staticClass: "modal-card-foot" },
        [
          _c("b-button", {
            attrs: {
              loading: _vm.isLoading,
              label: "אישור",
              type: "is-primary"
            },
            on: { click: _vm.save }
          }),
          _c("b-button", {
            attrs: { disabled: _vm.isLoading, label: "ביטול" },
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }